import packageJson from '../../package.json';

const STORAGE_URL = '';

const API_TARGETS = {
  dev: 'http://127.0.0.1:8000/api/',
  prod: 'https://api.snapnbill.com/api/',
};

// Set to 'dev' or 'prod' to force a target locally. Leave empty to follow NODE_ENV / BASE_URL.
const API_TARGET_OVERRIDE = '';

const normalizeUrl = url => (url && url.endsWith('/') ? url : `${url}/`);
const defaultTarget = process.env.NODE_ENV === 'development' ? 'dev' : 'prod';
const resolvedTarget = API_TARGET_OVERRIDE || defaultTarget;
const API_URL = API_TARGET_OVERRIDE
  ? API_TARGETS[resolvedTarget]
  : normalizeUrl(process.env.BASE_URL || API_TARGETS[defaultTarget]);

export const storagePath = STORAGE_URL;
export const apiUrl = API_URL;
export const activeApiTarget = resolvedTarget;
export const appVersion = packageJson.version;



// WEBPACK FOOTER //
// ./src/config/index.js